import React, { Component } from "react";
import API from "../../apiService.js";
import ReactToPrint from "react-to-print";
import PrintButton from "../medical/PrintButton";
import moment from "moment";
import FormPeriksaPrint from "./FormPeriksaPrint";

export default class SuratPeriksaList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      letters:
        this.props.letters.length > 0
          ? this.props.letters
          : [],
    };
  }

  render() {
    console.log(this.props);
    let list = this.props.letters.map((data, key) => {
      if (key > 0) {
        return (
          <div
            className='alert alert-success  alert-dismissible fade show row'
            role='alert'
            key={key}>
            <span className='alert-icon'>
              <i className='bus-front-12' />
            </span>
            <span className='alert-text'>
              Tanggal Kunjungan : {moment(data.created_at).format("YYYY-MM-DD")}{" "}
            </span>
            <div style={{ marginLeft: "1%" }}>
              {/* <ReactToPrint
                // copyStyles ={true}
                trigger={() => (
                  <a href="#">
                    <button className="btn btn-success">Cetak </button>
                  </a>
                )}
                content={() => this.componentRef}
              /> */}
              <PrintButton
                url={`/registration/color_blind/print/${data.id}`}
                buttonText='Cetak'
                color='secondary'
              />
              <div style={{ display: "none" }}>
                <FormPeriksaPrint
                  ref={(el) => (this.componentRef = el)}
                  patient={this.props.patient}
                  letter={data}
                />{" "}
              </div>
            </div>
          </div>
        );
      }
    });
    return <div>{list}</div>;
  }
}
